import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { snapDraftBailiffDetail } from "store/bailiff/draft/bailiff/draft_bailiff.action";
import {
  getAudioUrl,
  snapDraftDialogDetail,
  unSnapDraftDialogDetail,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import { setHighlight } from "store/bailiff/nav/nav.action";

//
//component
//redux
//selector
//actions
export const TriggerDetail = () => {
  // -------------------------- VAR ----------------------------
  const params = useParams();
  const { bailiffId, slotId } = params;

  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  // -------------------------- USE EFFECT ---------------------
  useEffect(() => {
    dispatch(setHighlight(["1"]));
  }, [dispatch]);

  useEffect(() => {
    if (bailiffId) {
      dispatch(snapDraftBailiffDetail({ bailiffId }));
    }

    return () => dispatch(unSnapDraftDialogDetail());
  }, [bailiffId, dispatch]);

  // sbap dialog
  useEffect(() => {
    if (bailiffId && slotId) {
      const id = `${bailiffId}-${slotId}`;
      dispatch(snapDraftDialogDetail({ dialogId: id }));
    }

    return () => dispatch(unSnapDraftDialogDetail());
  }, [bailiffId, slotId, dispatch]);

  // GET AUDIO URL
  useEffect(() => {
    if (bailiffId && slotId) {
      dispatch(getAudioUrl({ bailiff: bailiffId, part: slotId }));
    }
  }, [bailiffId, slotId, dispatch]);

  // -------------------------- RETURN --------------------------
  return <></>;
};
export default TriggerDetail;
